<template>
  <div>
    <button-link v-if="!isOnboardingIntegration" class="integration_back_button" @click="goToIntegrationsTab">Back to Integrations</button-link>

    <section-box class="integration_header">
      <img
        v-if="logoPath"
        class="integration_header--logo"
        :src="logoPath"
        :alt="heading"
      />
      <h1 class="integration_header--heading">{{ heading }}</h1>

      <div class="ml-auto flex">
        <slot name="buttons"></slot>
      </div>
    </section-box>

    <div style="position: relative">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "IntegrationTabWrapper",
  props: {
    heading: {
      type: String,
      required: true,
    },
    logoPath: String,
    isOnboardingIntegration: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    goToIntegrationsTab() {
      this.$router.push({name: "settings", params: {'tab': 'integrations'}})
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.integration_back_button {
  margin: 2rem 0 1rem;
}

.integration_header {
  display: flex;
  align-items: center;

  &--logo {
    height: 32px;
    margin-right: 8px;
  }

  &--heading {
    font-size: 2rem;
    font-weight: bold;
    color: $text-muted;
  }
}
</style>
